import {
  createInventorizationIssue,
  INVENTORIZATION_BLOCK_IDS,
  readInventorizationBlockStatus,
} from '@/features/inventorization/domain/inventorization';
import type { InventorizationTechnicalDetails } from '@/features/inventorization/domain/inventorization-technical';
import { isRemoteReadingMountType } from '@/features/inventorization/domain/inventorization-technical-mount-type';
import type { BlockStatus, ValidationIssue } from '@/shared/capture/capture-session';
import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

export function validateInventorizationTechnicalDetails(technical: InventorizationTechnicalDetails): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  const blockId = INVENTORIZATION_BLOCK_IDS.technical;

  if (!technical.monitoredEntity.trim()) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'TECHNICAL_MONITORED_ENTITY_MISSING',
        translateInventoryText(
          'app.inventory.validation.technical.monitoredEntityRequired',
          'Monitored entity is required.',
        ),
      ),
    );
  }

  if (!technical.accessibility?.length) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'TECHNICAL_ACCESSIBILITY_MISSING',
        translateInventoryText(
          'app.inventory.validation.technical.accessibilityRequired',
          'Accessibility is required.',
        ),
      ),
    );
  }

  if (!technical.mountType) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'TECHNICAL_MOUNT_TYPE_MISSING',
        translateInventoryText('app.inventory.validation.technical.mountTypeRequired', 'Mount type is required.'),
      ),
    );
  }

  if (isRemoteReadingMountType(technical.mountType) && !technical.remoteReadingOwner.trim()) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'TECHNICAL_REMOTE_READING_OWNER_MISSING',
        translateInventoryText(
          'app.inventory.validation.technical.remoteReadingOwnerRequired',
          'Remote reading owner is required.',
        ),
      ),
    );
  }

  return issues;
}

export function getInventorizationTechnicalBlockStatus(technical: InventorizationTechnicalDetails): BlockStatus {
  return readInventorizationBlockStatus(validateInventorizationTechnicalDetails(technical));
}
